const enum ConfigurationFELInvoiceTypeEnum {
  PURCHASE_NUMBER = 4,
  SAG = 5,
  REGISTER = 6,
}
export { ConfigurationFELInvoiceTypeEnum }
